import HelloSign from "hellosign-embedded";
import { getEDocumentUrl, trackEvent } from "../app/utils";
import util from "./util";

function loadDirectDeposit() {

  const documentType = 4;

  //Instantiate HelloSign Client
  const helloSignClient = new HelloSign({
    clientId: util.helloSignId()
  });

  let data = {
    documentTypeId: documentType
  }

  getEDocumentUrl(data).then(url => {
    if (typeof url === "undefined") {
      /* empty */
    }
    else {
      //Initiate HelloSign
      helloSignClient.open(url, {
        allowCancel: true,
        debug: util.helloSignDebugMode(), // Enables debug output to console.log (default is false).
        skipDomainVerification: util.skipDomainVerification(), // This will work only if the Signature Request was created with test_mode=1.
      });
      helloSignClient.on('sign', () => {
        // heap custom event
        trackEvent("EFT - EFT Form - Submitted");
      });
      helloSignClient.on('cancel', () => {
        helloSignClient.close();
      });
      helloSignClient.on('error', () => {
        helloSignClient.close();
      });
      helloSignClient.on('send', () => {
        //only used for embedded requesting
      });
    }
  })
  .catch(() => {});
}

document.getElementById("btn-load-direct-deposit").addEventListener("click", loadDirectDeposit);
